export default __webpack_public_path__ + "static/media/couple-and-provider-2.27ec0d21.jpg";